import { render } from "./Pending.vue?vue&type=template&id=3b36b7b0&scoped=true"
const script = {}

import "./Pending.vue?vue&type=style&index=0&id=3b36b7b0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b36b7b0"

export default script